import React, { useState } from 'react'
import Avatar from '~/Common-Objects/Avatar/Avatar'
import ButtonSelect from '~/Common-Objects/UI/Forms/ButtonSelect/ButtonSelect'
import CheckBox from '~/Common-Objects/UI/Forms/CheckBox/CheckBox'
import Icons from '~/Common-Objects/UI/Icons/index'
import Multi from '~/Common-Objects/UI/Forms/Multi'
import Paper from '~/Common-Objects/UI/Paper/Paper'
import Select from '~/Common-Objects/UI/Forms/Select/Select'
import SquareChip from '~/Common-Objects/UI/Chips/SquareChip.jsx'
import TextInput from '~/Common-Objects/UI/Forms/TextInput/TextInput'
import i18n from '~/i18n'
import moment from 'moment'

const margin = 'mar-b10'

export default function ContactFields({
    contact,
    apps,
    updateCustomField = () => {},
    updatePhoneNumber = () => {},
    updateEmailAddress = () => {}
}) {
    const [expanded, setExpanded] = useState({ other: false })

    const renderCustomField = (field, index) => {
        const fieldIndex = contact.customFields.findIndex((f) => f.id == field.id)
        if (field.fieldType === 'DATE') {
            if (field.value === null || field.value == '' || !moment(field.value).isValid()) field.value = undefined
            return (
                <TextInput
                    outerClassName={margin}
                    key={'cf1_' + index}
                    disabled={field.readOnly}
                    label={field.fieldDesc}
                    type={field.ApplicationId === 8 && parseInt(field.ApplicationDataId) ? 'date' : 'datetime'}
                    id={field.fieldName}
                    value={field.value}
                    onChange={(ev, val) => updateCustomField(fieldIndex, val)}
                />
            )
        }
        if (field.fieldType === 'BOOLEAN') {
            return (
                <CheckBox
                    outerClassName={margin}
                    key={'cf2_' + index}
                    disabled={field.readOnly}
                    checked={field.value}
                    onChange={(ev) => updateCustomField(fieldIndex, ev.target.checked)}
                    name={field.fieldName}
                >
                    {field.fieldDesc}
                </CheckBox>
            )
        }
        if (field.fieldType === 'SELECT') {
            var theOpts = JSON.parse(JSON.stringify(field.options))
            if (!theOpts) theOpts = []
            theOpts.unshift({ value: '', label: '' })
            return (
                <Select
                    outerClassName={margin}
                    explainer={'Current Value: ' + field.value}
                    key={'cf3_' + index}
                    disabled={field.readOnly}
                    label={field.fieldDesc}
                    value={field.value}
                    onChange={(ev) => updateCustomField(fieldIndex, ev.currentTarget.value)}
                    name={field.fieldName}
                    data={theOpts}
                />
            )
        }

        if (field.fieldType === 'MULTISELECT' && Array.isArray(field.options)) {
            var theOpts = JSON.parse(JSON.stringify(field.options))
            if (!theOpts) theOpts = []

            var currVals = field.value
            if (!Array.isArray(currVals)) currVals = [currVals]

            let multiHeader = ''
            let multiHeaderIds = ''
            theOpts.forEach((theOpt) => {
                if (currVals.includes(theOpt.value)) {
                    theOpt.selected = true
                    multiHeader += theOpt.label + ', '
                    multiHeaderIds += theOpt.value + ', '
                }
            })

            if (multiHeader == '') {
                multiHeader = i18n.t('subscribers:index.clickHereToSelect')
            } else {
                multiHeader = multiHeader.slice(0, -2)
                multiHeaderIds = multiHeaderIds.slice(0, -2)
            }

            if (field.readOnly) {
                let theOptsFiltered = theOpts.filter((tO) => tO.selected)
                //just show chips for each selected field
                return (
                    <div className='form-group' key={'cf3_' + index}>
                        <div className='txtInput_label'>{field.fieldDesc}</div>
                        {!theOptsFiltered.length && (
                            <div className='txtInput_explainer mar-b10'>No {field.fieldDesc} selected yet</div>
                        )}
                        {theOptsFiltered.map((theOpt, index) => {
                            return (
                                <SquareChip key={index} className='square-chip-tag mar-b5 mar-r5'>
                                    {theOpt.label}
                                </SquareChip>
                            )
                        })}
                    </div>
                )
            }

            return (
                <div className='form-group' key={'cf3_' + index}>
                    <ButtonSelect
                        fixedHeight={true}
                        data={theOpts.map((theOpt) => {
                            return (
                                <CheckBox
                                    key={theOpt.value}
                                    name={theOpt.label}
                                    onChange={() => updateCustomField(fieldIndex, theOpt, 'multiselect', theOpts)}
                                    checked={theOpt.selected}
                                >
                                    {theOpt.label}
                                </CheckBox>
                            )
                        })}
                        explainer={'Current Value(s): ' + multiHeaderIds}
                        label={field.fieldDesc}
                        outerClassName={margin}
                        disabled={field.readOnly}
                        headerText={multiHeader}
                        filter={false}
                    >
                        {(!theOpts || !theOpts.length) && (
                            <span>{i18n.t('subscribers:subscriber.fields.noOptions')}</span>
                        )}
                    </ButtonSelect>
                </div>
            )
        }

        if (field.fieldType === 'MULTISELECT' && !Array.isArray(field.options)) {
            field.value = !Array.isArray(field.value) ? [] : field.value
            return (
                <div className='form-group' key={'cf4_' + index}>
                    <Multi
                        label={field.fieldDesc}
                        values={field.value}
                        outerClassName={margin}
                        disabled={field.readOnly}
                    />
                </div>
            )
        }

        if (field.fieldType === 'TELNO') {
            return (
                <div className='form-group' key={'cf4_' + index}>
                    <TextInput
                        outerClassName={margin}
                        disabled={field.readOnly}
                        label={field.fieldDesc}
                        style={{ width: '100%' }}
                        type={field.fieldType.toLowerCase()}
                        value={field.value}
                        onChange={(ev) => updatePhoneNumber(fieldIndex, ev.currentTarget.value, ev.valid)}
                    />
                </div>
            )
        }

        return (
            <div className='form-group' key={'cf4_' + index} id={field.id}>
                <TextInput
                    outerClassName={margin}
                    disabled={field.readOnly}
                    label={field.fieldDesc}
                    type={field.fieldType.toLowerCase()}
                    value={field.value}
                    onChange={(ev) => updateCustomField(fieldIndex, ev.currentTarget.value)}
                />
            </div>
        )
    }

    const important = contact.customFields.filter((f) => f.important)
    const notImportant = contact.customFields.filter((f) => !f.important && !f.ApplicationId)
    return (
        <div>
            <TextInput
                outerClassName={margin}
                label={i18n.t('subscribers:subscriber.email')}
                name='emailAddress-emailAddress'
                type='email'
                headerText={i18n.t('subscribers:subscriber.address') + ':'}
                onChange={updateEmailAddress}
                value={contact.emailAddress}
            />
            {important.map((field) => renderCustomField(field, 'important_' + field.id))}

            {!!notImportant.length && (
                <Paper style={{ padding: 20, marginTop: 20, maxHeight: 400, overflow: 'auto' }}>
                    <div
                        className='quickFlex'
                        style={{ cursor: 'pointer' }}
                        onClick={() => setExpanded((e) => ({ ...e, other: !e.other }))}
                    >
                        <Icons
                            icon='chevronRight'
                            className={expanded.other ? 'flipRight' : ''}
                            color='black'
                            style={{ marginRight: 12, display: 'flex', justifyContent: 'center', alignItems: 'center' }}
                        />
                        <div className='text-heavy'>
                            {important.length
                                ? i18n.t('subscribers:subscriber.fields.moreCustomFields')
                                : i18n.t('subscribers:subscriber.fields.customFields')}
                        </div>
                    </div>

                    {expanded.other && (
                        <div className='mar-t10' style={{ width: 328 }}>
                            {notImportant.map((field) => renderCustomField(field, 'notimportant_' + field.id))}
                        </div>
                    )}
                </Paper>
            )}

            {apps.map((app) => {
                const fields = contact.customFields.filter((f) => f.ApplicationId === app.ApplicationId && !f.important)
                if (!fields.length) return null

                return (
                    <Paper
                        key={app.ApplicationId}
                        style={{ padding: 20, marginTop: 20, maxHeight: 400, overflow: 'auto' }}
                    >
                        <div
                            className='quickFlex'
                            style={{ cursor: 'pointer' }}
                            onClick={() => setExpanded((e) => ({ ...e, [app.ApplicationId]: !e[app.ApplicationId] }))}
                        >
                            <Icons
                                icon='chevronRight'
                                className={expanded[app.ApplicationId] ? 'flipRight' : ''}
                                color='black'
                                style={{
                                    marginRight: 12,
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center'
                                }}
                            />
                            <div className='text-heavy'>
                                {i18n.t('subscribers:subscriber.fields.appFields', {
                                    appName: app.Application.appName
                                })}
                            </div>
                            <div style={{ flexGrow: 1, display: 'flex', flexDirection: 'row-reverse' }}>
                                <Avatar src={app.Application.appLogoUri} style={{ height: 25, width: 25 }} />
                            </div>
                        </div>

                        {expanded[app.ApplicationId] && (
                            <div className='mar-t10' style={{ width: 328 }}>
                                {fields.map((field) => renderCustomField(field, app.ApplicationId + '_' + field.id))}
                            </div>
                        )}
                    </Paper>
                )
            })}
        </div>
    )
}
